import { render } from "./HrWithText.vue?vue&type=template&id=826d9e98&ts=true"
import script from "./HrWithText.vue?vue&type=script&lang=ts"
export * from "./HrWithText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__